import React from 'react';
import { Text, Pressable, StyleSheet } from 'react-native';
import Style from '../../../../../../../../constants/Style';
import Colors from '../../../../../../../../constants/Colors';
import { PressableState } from '../../../../../../../PressableStyled';
import isMobile from '../../../../../../../IsMobile';

export interface OptionProps {
  text: string,
  onPress: () => void,
  selected?: boolean,
  testID?: string,
}

const Option = ({
  text, onPress, testID,
}: OptionProps) => <Pressable
  {...{ onPress, testID }}
  style={({ hovered, pressed }: PressableState) => [
    styles.option,
    hovered && Style.listItemHovered, pressed && Style.listItemPressed,
  ]}
>
    <Text style={[styles.optionText]}>
      {text}
    </Text>
  </Pressable>;

const styles = StyleSheet.create({
  option: {
    borderRadius: isMobile ? 6 : undefined,
  },
  optionText: {
    paddingHorizontal: 12,
    paddingVertical: 9,
    fontSize: 14,
    lineHeight: 21,
    fontFamily: 'Poppins_400Regular',
    color: Colors.light.hereworksBlack600,
  },
});

export default Option;
